import { Checkbox, Chip, FormControlLabel, Theme, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ChangeEvent, FC } from "react";
import { Agency, AgencyCategory, AgencyIds, FilterKey } from "../../../../../reducers/states/agency";
import { customTheme } from "../../../../..";
import { useAgency } from "../../../../../hooks/agencies";
import { AgencyDelimeter } from "../../../../../reducers/states/agency/wsp";

const useStyles = makeStyles((theme: Theme) => ({
  filter: {
    paddingRight: 0,
    marginRight: 0,
    marginLeft: 0,
  },
  notAvailable: {
    color: theme.palette.error.main,
  },
}));

interface AgencyFilterProps {
  label: string;
  selectedFilters: string[];
  filterKey: FilterKey;
  isFeedDown: boolean;
  tooltip?: string;
  useAgencyColor?: boolean;
  handleAgencySelect: (event: ChangeEvent<HTMLInputElement>) => void;
}

const AgencyFilter: FC<AgencyFilterProps> = (props) => {
  const classes = useStyles();
  const id = props.filterKey.toString().split(AgencyDelimeter)[0]; // If props.filterKey is a delimter, the split will give us the Agency ID. 
  const agency = useAgency(id); // if props.filterKey is a JogId, agency will be undefined.

  const getChipColor = (agency: Agency | undefined) => {
    if (!agency || props.useAgencyColor === false) return customTheme.palette.primary.main;

    switch (agency.id) {
      case AgencyIds.KingCountyMetro:
        return customTheme.agency.KCM;
      case AgencyIds.WSP:
        return customTheme.agency.WSP;
    }

    switch (agency.category) {
      case AgencyCategory.Fire:
        return customTheme.category.Fire;
      case AgencyCategory.LawEnforcement:
        return customTheme.category.LawEnforcement
    }

    return customTheme.palette.primary.main;
  };

  return (
    <FormControlLabel
      className={classes.filter}
      control={
        <Tooltip title={props.tooltip ?? undefined}>
          <Checkbox
            name={props.filterKey as string}
            value={props.filterKey}
            checked={props.selectedFilters.includes(props.filterKey as string)}
            onChange={props.handleAgencySelect}
            checkedIcon={
              <Chip
                style={{ backgroundColor: getChipColor(agency), color: "white" }}
                variant="filled"
                label={props.label}
              />
            }
            icon={<Chip variant="outlined" label={props.label} />}
            sx={{ padding: "5px" }}
          />
        </Tooltip>
      }
      label={
        props.isFeedDown ? (
          <Tooltip
            title={
              props.label +
              "'s data feed is currently down or experiencing problems. The system will check for updates in 30 seconds"
            }
          >
            <HighlightOffIcon className={classes.notAvailable} />
          </Tooltip>
        ) : (
          undefined
        )
      }
    />
  );
};

export default AgencyFilter;
